import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { QueryKeyLocalStorageEnum, PositionNameSortEnum } from 'context/query/queryContext/QueryContext.enum';
import { Table } from 'ui/table/Table';

import * as Styled from './PositionsTableHeader.styles';

export const PositionsTableHeader = () => {
  const { formatMessage } = useLocale();

  return (
    <Styled.HeaderWrapper>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.POSITIONS}
        sortBy={PositionNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['definitions.positions.header.name'] })}
      />
    </Styled.HeaderWrapper>
  );
};
